import Dispatcher from "../dispatcher";

export default {
  block(id) {
    Jigsaw.User.block(id, response => {
      if (response.isSuccess()) {
        const block = response.data.user;
        Dispatcher.emit(Dispatcher.FOLLOWER_BLOCKED, id, block);
        Fraction.Helpers.toast(i18n.t("sharing.user-blocked"), {
          centered: true
        });
        Fraction.Reporter.gaEvent("sharing/followers/block-follower");
      }
    });
  },

  unblock(id) {
    Jigsaw.User.unblock(id, response => {
      if (response.isSuccess()) {
        Dispatcher.emit(Dispatcher.USER_UNBLOCKED, id, response.data.user);
        Fraction.Helpers.toast(i18n.t("sharing.user-unblocked"), {
          centered: true
        });
        Fraction.Reporter.gaEvent("sharing/followers/unblock-follower");
      }
    });
  },

  get() {
    Promise.all([this._getFollowers(), this._getBlocks()])
      .then(arrays => {
        const [followers, blocks] = arrays;
        Dispatcher.emit(
          Dispatcher.RECEIVE_FOLLOWERS_AND_BLOCKS,
          followers,
          blocks
        );
      })
      .catch(reason => {
        switch (reason) {
          case "logged out":
            Fraction.Helpers.signin();
            break;
          default:
            Dispatcher.emit(Dispatcher.GET_FOLLOWERS_AND_BLOCKS_ERROR);
        }
      });
  },

  _getFollowers() {
    return new Promise((resolve, reject) => {
      Jigsaw.User.getFollowers(response => {
        if (response.isSuccess()) {
          const followers = response.data.user;
          resolve(followers);
        } else if (response.data.code === 401) {
          reject("logged out");
        } else {
          reject();
        }
      });
    });
  },

  _getBlocks() {
    return new Promise((resolve, reject) => {
      Jigsaw.User.getBlocks(response => {
        if (response.isSuccess()) {
          const blocks = response.data.user;
          resolve(blocks);
        } else if (response.data.code === 401) {
          reject("logged out");
        } else {
          reject();
        }
      });
    });
  }
};
